import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar from "@mui/material/AppBar";
import {IconButton, Toolbar, Typography} from "@mui/material";
import {DrawerItem} from "../../core/model/DrawerItem";
import {ReactNode} from "react";
import {SxProps, Theme} from "@mui/material";
import {UserActions} from "@components/user-actions";
import {translate} from "@util";
import {useDownBreakpoint} from "@hooks";

const AppBar = ({
  sx,
  open,
  drawerItems,
  drawerItemIndex,
  onDrawerChange,
}: {
  drawerItems: (DrawerItem | ReactNode)[];
  open: boolean;
  drawerItemIndex: number;
  sx?: SxProps<Theme>;
  onDrawerChange: (open: boolean) => void;
}) => {
  const isDownSm = useDownBreakpoint("sm");
  const title = translate(
    (drawerItems[drawerItemIndex] as DrawerItem)?.i18n ?? "",
  );

  const handleClick = () => {
    onDrawerChange(!open);
  };

  return (
    <MuiAppBar
      position="absolute"
      sx={{...sx, background: "unset", px: isDownSm ? 0 : 1}}>
      <Toolbar>
        <IconButton
          edge="start"
          aria-label="open drawer"
          onClick={handleClick}
          sx={{marginRight: "16px"}}>
          <MenuIcon color="action" />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          noWrap
          sx={{flexGrow: 1}}
          color="textPrimary">
          {title}
        </Typography>
        <UserActions size="medium" />
      </Toolbar>
    </MuiAppBar>
  );
};

export {AppBar};
